import React from 'react';
import DataTableComponent from 'datatables.net-react';
import DataTable from 'datatables.net-dt';

const PAGE_LENGTH = 20;
DataTable.ext.oSort['natural-asc'] = function (a, b) {
  // console.log('Sorting ASC:', a, b); // 用於檢查排序過程

  // 將 a 和 b 轉換為字串，並移除 <i> 標籤及其內容
  a = a
    .toString()
    .replace(/<i.*?>.*?<\/i>/g, '')
    .replace('樓', '');
  b = b
    .toString()
    .replace(/<i.*?>.*?<\/i>/g, '')
    .replace('樓', '');

  // 如果兩個都是純數字，直接進行數字比較（升序）
  if (/^\d+$/.test(a) && /^\d+$/.test(b)) {
    return parseInt(a, 10) - parseInt(b, 10);
  }

  // 如果兩者都是字母加數字組合，則按字母降序比較
  if (/^[a-zA-Z]+\d+$/.test(a) && /^[a-zA-Z]+\d+$/.test(b)) {
    const aLetter = a.match(/[a-zA-Z]+/)[0];
    const bLetter = b.match(/[a-zA-Z]+/)[0];

    // 字母部分按降序排列
    if (a < b) return 1;
    if (a > b) return -1;
    if (aLetter < bLetter) return 1;
    if (aLetter > bLetter) return -1;

    // 如果字母部分相同，則比較數字部分，按升序排列
    const aNumber = parseInt(a.match(/\d+/)[0], 10);
    const bNumber = parseInt(b.match(/\d+/)[0], 10);
    return aNumber - bNumber;
  }

  // 如果一個是純數字，另一個是字母加數字組合，字母加數字組合優先
  if (/^\d+$/.test(a) && /^[a-zA-Z]+\d+$/.test(b)) return 1;
  if (/^[a-zA-Z]+\d+$/.test(a) && /^\d+$/.test(b)) return -1;

  // 其餘情況按字串進行比較
  return a.localeCompare(b);
};

DataTable.ext.oSort['natural-desc'] = function (a, b) {
  // console.log('Sorting DESC:', a, b); // 用於檢查排序過程

  // 將 a 和 b 轉換為字串
  a = a
    .toString()
    .replace(/<i.*?>.*?<\/i>/g, '')
    .replace('樓', '');
  b = b
    .toString()
    .replace(/<i.*?>.*?<\/i>/g, '')
    .replace('樓', '');

  // 檢查 a 和 b 是否是純數字
  const aIsNumber = /^\d+$/.test(a);
  const bIsNumber = /^\d+$/.test(b);

  // 如果兩者都是數字，則按數字進行降序排序
  if (aIsNumber && bIsNumber) {
    return parseInt(b, 10) - parseInt(a, 10); // 確保數字部分降序排列
  }

  // 如果只有一個是數字，讓數字優先排在前面
  if (aIsNumber) return -1; // a 是數字，排在前面
  if (bIsNumber) return 1; // b 是數字，排在前面

  // 將非純數字部分按 ASCII 值降序比較
  if (a < b) return -1; // 保持 ASCII 升序
  if (a > b) return 1; // 保持 ASCII 升序

  return 0; // 如果完全相同，返回 0
};

DataTableComponent.use(DataTable);
export default ({
  children,
  tableRef,
  options: passthroughOptions,
  ...restProps
}) => {
  const options = {
    retrieve: true,
    language: {
      info: '共 _TOTAL_ 筆資料',
      infoEmpty: '沒有資料',
      lengthMenu: '每頁顯示 _MENU_ 筆資料',
      loadingRecords: '資料載入中...',
      processing:
        '<div class="rbt-loader spinner-border spinner-border-md" ></div><div>資料載入中...</div>',
      zeroRecords: '找不到資料',
    },
    dom: 'rt<"dt-bottom" <"dt-info"i><"dt-paging"p>>',
    searching: false,
    processing: true,
    lengthMenu: [20, 50, 100],
    select: true,
    pageLength: PAGE_LENGTH,
    responsive: true,
    scrollCollapse: true,
    scrollY: '45vh',
    paging: true,
    scrollX: true,
    ...passthroughOptions,
  };

  return (
    <DataTableComponent ref={tableRef} options={options} {...restProps}>
      {children}
    </DataTableComponent>
  );
};
